import type { PaginationResultsMeta, ResponseMeta } from './types';

export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
export const DEFAULT_PAGINATION_META: PaginationResultsMeta = {
  page: 0,
  limit: 0,
  total: 0,
  hasMore: false,
};

export const DEFAULT_RESPONSE_META: ResponseMeta = {
  activeFilters: [],
};

export const DEFAULT_TABLE_FEATURES = {
  enablePagination: true,
  enableFiltering: true,
  enableRowExpansion: false,
  enableSorting: true,
  enableLocalPreferences: true,
  enableUrlState: true,
  showToolbar: true,
  showCardWrapper: true,
  showShadow: true,
} as const;
